import React from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

// Register chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const LineGraph = ({ data, label, color }) => {
  // Reduce data to show every Nth item (e.g., every 60th data point)
  const reducedData = data?.filter((_, index) => index % 60 === 0);

  // Reverse the reducedData so that it shows in the reverse order
  const reversedData = reducedData?.reverse();

  const chartData = {
    labels: reversedData?.map((item) =>
      new Date(item.createdAt)?.toLocaleDateString()
    ),
    datasets: [
      {
        label: label,
        data: reversedData?.map((item) => item[label]),
        borderColor: color,
        tension: 0.4,
      },
    ],
  };

  return (
    <Line
      data={chartData}
      options={{
        responsive: true,
        plugins: {
          legend: { position: "top" },
          tooltip: { mode: "index" },
        },
        scales: {
          x: {
            ticks: {
              maxRotation: 0, // Prevent x-axis labels from rotating
              autoSkip: true, // Automatically skip labels that are too close
            },
          },
          y: {
            ticks: {
              beginAtZero: true,
            },
          },
        },
        elements: {
          point: {
            radius: 3, // Reduce point size
          },
        },
      }}
    />
  );
};

export default LineGraph;
